import { render, staticRenderFns } from "./BuyMeCreditsPopup.vue?vue&type=template&id=1d500b68&scoped=true&"
import script from "./BuyMeCreditsPopup.vue?vue&type=script&lang=js&"
export * from "./BuyMeCreditsPopup.vue?vue&type=script&lang=js&"
import style0 from "./BuyMeCreditsPopup.vue?vue&type=style&index=0&id=1d500b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d500b68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d500b68')) {
      api.createRecord('1d500b68', component.options)
    } else {
      api.reload('1d500b68', component.options)
    }
    module.hot.accept("./BuyMeCreditsPopup.vue?vue&type=template&id=1d500b68&scoped=true&", function () {
      api.rerender('1d500b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/BuyMeCreditsPopup.vue"
export default component.exports